import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ValetWithholding} from '../../../../../../common-modules/common-valet/models/valet-withholding';
import {NbDialogRef} from '@nebular/theme';
import {PvRecruitmentService, User} from '../../../../pv-recruitment.service';

@Component({
    selector: 'pv-pv-recruitment-qonto-dialog',
    templateUrl: './pv-recruitment-qonto-dialog.component.html',
    styleUrls: ['./pv-recruitment-qonto-dialog.component.scss'],
    standalone: false
})
export class PvRecruitmentQontoDialogComponent implements OnInit {
  @Input() candidateInfoForm: FormGroup;
  @Input() candidateUser: User;
  @Input() retry: boolean;
  @Output() submitEvent = new EventEmitter<ValetWithholding | void>();

  public form: FormGroup;

  constructor(protected dialogRef: NbDialogRef<PvRecruitmentQontoDialogComponent>,
              private fb: FormBuilder,
              private recruitmentService: PvRecruitmentService) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      answer: [false, [Validators.required]],
    });
  }

  acceptQontoOffer() {
    let formData: any;

    if (this.retry && this.candidateUser) {
      formData = {
        firstName: this.candidateUser.firstName,
        lastName: this.candidateUser.lastName,
        email: this.candidateUser.email,
        phone: this.candidateUser.phone,
      };
    } else if (!this.retry && this.candidateInfoForm) {
      formData = {
        firstName: this.candidateInfoForm.get('firstName').value,
        lastName: this.candidateInfoForm.get('lastName').value,
        email: this.candidateInfoForm.get('email').value,
        phone: this.candidateInfoForm.get('phone').value,
      };
    } else {
      console.error('No candidate data available to send to Qonto');
      return;
    }

    this.recruitmentService.sendCandidateDataToQonto(formData).then(() => {
      this.closeDialog();
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
